(function () {
  'use strict';
  angular.module('vcexam')
    .component('gdtsoftwareconfig', {
      restrict: 'E',
      bindings: {},
      template: `
        <div class="panel panel-info">
        <div class="panel-heading">
          <h3>GDT Software Endpunkt</h3>
        </div>
        <div class="panel-body"></div>
          <div class="modalspacer">
            <label>Bezeichnung des GDT Softwareendpunkts</label>
            <listeditor list="vm.gdtsoftware.gdtsoftware" parentsave="vm.childsavepat(list)"></listeditor>
          </div>
        </div>
 
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService',
        function ($log, Config, Rlog, vertxEventBusService) {
          let vm = this;
          vm.childsavepat = childsavepat;

          vm.$onInit = function () {

            Config.$find('gdtsoftware').$then(function (gdtsoftware) {
              vm.gdtsoftware = gdtsoftware;
              // intialize if still empty
              if (angular.isUndefined(vm.gdtsoftware.gdtsoftware)) {
                vm.gdtsoftware._id = 'gdtsoftware';
                vm.gdtsoftware.gdtsoftware = [];
              }
            });
          };




          function childsavepat(list) {
            vm.gdtsoftware.gdtsoftware = list;
            savepat();
          }
          

          function savepat() {
            if (vm.gdtsoftware.$hasPendingActions()) {
              vm.gdtsoftware.$cancel();
            }
            vm.gdtsoftware.$save();
          }


          vertxEventBusService.on('config.update', function (message) {
            // $log.debug('debug: config update received: ', message);
            let messages = message.split(':');

            if (messages[0] === 'gdtsoftware' && angular.isDefined(vm.gdtsoftware)) {
              vm.gdtsoftware.$refresh().$then(function () {
                $log.debug('debug: config refresh gdtsoftware');
              }, function (error) {
                $log.debug('debug: config refresh gdtsoftware failed: ', error);
              });
            }
          });


          vm.$onDestroy = function () {
            $log.debug('[Vert.x unsubscribe] config.update');

            vertxEventBusService.unregisterHandler('config.update', {}, () => {
            }, (err) => {
              $log.error('Failed to unregister examinations.update handler: ', err);
            });
          };



        }] // controller
    }); // component

// klammerfriedhof
}());
